import { Meilisearch } from "meilisearch";
import Logger from "@cappelendamm/logger";

function createUnavailableSearchClient() {
  return {
    index() {
      return {
        searchForFacetValues: async () => ({ facetHits: [] }),
      };
    },
    multiSearch: async () => ({ results: [] }),
  } as unknown as Meilisearch;
}

const host = process.env.NEXT_PUBLIC_MEILISEARCH_URL;
const apiKey = process.env.NEXT_PUBLIC_MEILISEARCH_NETTHANDEL_SEARCH_KEY;

export const searchClient =
  host && apiKey
    ? new Meilisearch({
        host,
        apiKey,
      })
    : (Logger.error(
        "One or more MeiliSearch environment variables are not defined",
      ),
      createUnavailableSearchClient());
